import React from "react";
import ScrollToTop from "components/common/scrollToTop";

import Modal from "./components/common/modal";
import Router from "./routes";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AsyncBoundary from "components/common/asyncBoundary";
import RootLoading from "components/common/loadingUI/rootLoading";
import NotFoundPage from "pages/404";

function App() {
  return (
    <AsyncBoundary
      errorFallback={<NotFoundPage />}
      suspenseFallback={<RootLoading />}
    >
      <>
        <ScrollToTop />
        <Modal />
        <Router />
        {process.env.NODE_ENV === "production" ? null : (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </>
    </AsyncBoundary>
  );
}

export default App;
